import { store } from 'DashboardUser/store'
import { Provider } from 'react-redux'
import { useAct } from 'DashboardUser/store'
import DashboardTargetTable from './DashboardTargetTable'
import Loading from 'Shared/components/Loading'

const DashboardPreviewContent = ({ dashboardId }) => {
  const act = useAct()
  const loaded = useSel(s => s.app.loaded)

  useEffect(() => {
    if (!dashboardId) return

    act.app.load(dashboardId)
    act.app.loadMe()
    act.app.reloadTargets()
  }, [dashboardId])

  return (
    <div className='dashboard-user-root no-pointer-events'>
      <div className='content'>
        {loaded ? <DashboardTargetTable preview={true} /> : <Loading />}
      </div>
    </div>
  )
}

export default function DashboardPreview(params) {
  return (
    <Provider store={store}>
      <DashboardPreviewContent {...params} />
    </Provider>
  )
}
